import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DiffusionService } from 'src/services/diffusion.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-delete-diffusion-dialog',
    imports: [MatDialogModule, TranslateModule],
    templateUrl: './delete-diffusion-dialog.component.html',
    styleUrls: ['./delete-diffusion-dialog.component.scss']
})
export class DeleteDiffusionDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteDiffusionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { diffusionId: number, utilisateurId: number },
    private diffusionService: DiffusionService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }

  confirmerSuppression(): void {
    this.diffusionService.supprimerDiffusion(this.data.diffusionId, this.data.utilisateurId).subscribe({
      next: () => {
        this.translateService.get('DIFFUSION.DELETION_SUCCESSFUL').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(true);
      },
      error: () => {
        this.translateService.get('DIFFUSION.DELETION_ERROR').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(false);
      }
    });
  }

  annuler(): void {
    this.dialogRef.close(false);
  }
}
